import createAction from 'redux-actions/es/createAction';

export const cySecVerificationPageOpened = createAction('CY_SEC_VERIFICATION_PAGE_OPENED');

export const updatePersonalDetailsRequest = createAction('UPDATE_PERSONAL_DETAILS_REQUEST');
export const updatePersonalDetailsSuccess = createAction('UPDATE_PERSONAL_DETAILS_SUCCESS');
export const updatePersonalDetailsFail = createAction('UPDATE_PERSONAL_DETAILS_FAIL');

export const cySecVerificationUpdateRequest = createAction('CY_SEC_VERIFICATION_UPDATE_REQUEST');
export const cySecVerificationUpdateSuccess = createAction('CY_SEC_VERIFICATION_UPDATE_SUCCESS');
export const cySecVerificationUpdateFail = createAction('CY_SEC_VERIFICATION_UPDATE_FAIL');
export const verificationStepIdDuplicate = createAction('VERIFICATION_STEP_ID_DUPLICATE');
export const duplicateIdDifferentSteps = createAction('DUPLICATE_ID_DIFFERENT_STEPS');

export const cySecVerificationSecondStepUpdateRequest = createAction(
  'CY_SEC_VERIFICATION_SECOND_STEP_UPDATE_REQUEST',
);
export const cySecVerificationSecondStepUpdateSuccess = createAction(
  'CY_SEC_VERIFICATION_SECOND_STEP_UPDATE_SUCCESS',
);
export const cySecVerificationSecondStepUpdateFail = createAction(
  'CY_SEC_VERIFICATION_SECOND_STEP_UPDATE_FAIL',
);

export const getVerificationUserRequest = createAction('GET_VERIFICATION_USER_REQUEST');
export const getVerificationUserSuccess = createAction('GET_VERIFICATION_USER_SUCCESS');
export const getVerificationUserFail = createAction('GET_VERIFICATION_USER_FAIL');

export const getApplicationLogRequest = createAction('GET_APPLICATION_LOG_REQUEST');
export const getApplicationLogSuccess = createAction('GET_APPLICATION_LOG_SUCCESS');
export const getApplicationLogFail = createAction('GET_APPLICATION_LOG_FAIL');

export const initializePersonalDetails = createAction('INITIALIZE_PERSONAL_DETAILS');
export const initializeSettingsVerification = createAction('INITIALIZE_SETTINGS_VERIFICATION');
export const initializeCySecVerification = createAction('INITIALIZE_CY_SEC_VERIFICATION');
export const initializeCySecVerificationSecondStep = createAction(
  'INITIALIZE_CY_SEC_VERIFICATION_SECOND_STEP',
);

export const changeStepForce = createAction('CHANGE_STEP_FORCE');

export const uploadRearSideClose = createAction('UPLOAD_REAR_SIDE_CLOSE');
export const uploadRearSideOpen = createAction('UPLOAD_REAR_SIDE_OPEN');

export const showCySecVerificationFeedback = createAction('SHOW_CY_SEC_VERIFICATION_FEEDBACK');
export const hideCySecVerificationFeedback = createAction('HIDE_CY_SEC_VERIFICATION_FEEDBACK');
export const showAccountSettingsFeedback = createAction('SHOW_ACCOUNT_SETTINGS_FEEDBACK');
export const hideAccountSettingsFeedback = createAction('HIDE_ACCOUNT_SETTINGS_FEEDBACK');
export const showAccountSettingsCongratulations = createAction(
  'SHOW_ACCOUNT_SETTINGS_CONGRATULATIONS',
);
export const hideAccountSettingsCongratulations = createAction(
  'HIDE_ACCOUNT_SETTINGS_CONGRATULATIONS',
);

export const acceptTradeWithRestrictionsRequest = createAction(
  'ACCEPT_TRADE_WITH_RESTRICTIONS_REQUEST',
);
export const acceptTradeWithRestrictionsSuccess = createAction(
  'ACCEPT_TRADE_WITH_RESTRICTIONS_SUCCESS',
);
export const acceptTradeWithRestrictionsFail = createAction('ACCEPT_TRADE_WITH_RESTRICTIONS_FAIL');

export const redirectionToStartTrading = createAction('REDIRECTION_TO_START_TRADING');

export const getTinValidationsRequest = createAction('GET_TIN_VALIDATIONS_REQUEST');
export const getTinValidationsSuccess = createAction('GET_TIN_VALIDATIONS_SUCCESS');
export const getTinValidationsFail = createAction('GET_TIN_VALIDATIONS_FAIL');
